export default __webpack_public_path__ + "static/media/tipo-teste.c8c9882c.png";